import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { WiredSubscriptionDetails } from "../../types";
import { SubscriptionViewBase } from "../subscription-view-base";
import { AlertsSection } from "./components/alerts-section/alerts-section";
import { DevicesSection } from "./components/devices-section/devices-section";
import { WiredShortcutMenuComponent } from "./components/wired-shortcut-menu/wired-shortcut-menu";

@Component({
  selector: "wired-subscription-view",
  templateUrl: "wired-subscription-view.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    AlertsSection,
    AngularSvgIconModule,
    DevicesSection,
    RouterModule,
    SubscriptionDatePipe,
    SubscriptionDetailHeader,
    TranslatePipe,
    WiredShortcutMenuComponent,
  ],
})
export class WiredSubscriptionViewComponent extends SubscriptionViewBase<WiredSubscriptionDetails> {
  protected customCustomerAbbreviation = computed(() => this.subscription().customCustomerAbbreviation ?? null);
  protected monitoringEnabled = computed(() => this.subscription().monitoringEnabled);
}
